import React from "react";
import { Trans, WithTranslation } from "react-i18next";
import styled from "styled-components";

const SalesLink = styled.a`
    color: #11a9e2;
`;

const SalesText = styled.div`
    float: left;
    color: #6d6d6d;
    letter-spacing: 0.1px;
    margin-top: 15px;
    font-size: 14px;
`;

type TranslationFn = WithTranslation["t"];

export function TeamCheckoutSalesLink({ t }: { t: TranslationFn }) {
    return (
        <SalesText>
            <Trans
                t={t}
                i18nKey="Interested in a custom trial? <salesLink>Contact sales</salesLink>"
                components={{ salesLink: <SalesLink href="mailto:sales@beautiful.ai" /> }}
            />
        </SalesText>
    );
}
